import React, { useEffect, useState } from "react";
import ProductImages from "./ProductImages";
import LoadingProduct from "./LoadingProduct";
import ProductMarque from "./productmarque/ProductMarque";
import ViewMoreProduct from "./ViewMoreProduct";
import { useInView } from "react-intersection-observer";
import { useAnimation, motion } from "motion/react";
import "./productimage.css";
import "./productnew.css";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import gsap from "gsap";
gsap.registerPlugin(ScrollTrigger);

const Product = () => {
  const [containerOpacity, setContainerOpacity] = useState(1);
  const [marqueeOpacity, setMarqueeOpacity] = useState(0);
  const [viewMoreOpacity, setViewMoreOpacity] = useState(0);
  const { ref: containerref, inView: containerview } = useInView({
    onChange: (inView) => setContainerOpacity(inView ? 1 : 0),
    threshold: 0.5,
  });

  const { ref: ref, inView: produvview } = useInView({
    onChange: (inView) => setMarqueeOpacity(inView ? 1 : 0),
    threshold: 0.7,
  });

  const { ref: ref1, inView: view1 } = useInView({
    onChange: (inView) => setViewMoreOpacity(inView ? 1 : 0),
    threshold: 0.8,
  });
  useEffect(() => {
    const boxes = gsap.utils.toArray(".product-insidebox");

    gsap
      .timeline({
        scrollTrigger: {
          trigger: ".product-container",
          scroller: "#topScrool",
          start: "top top",
          end: "bottom+=200%",
          scrub: 1,
          pin: true,
        },
      })
      // Box 1 fades out and slides back
      .to(boxes[0], {
        opacity: 0,
        zIndex: 1,

        duration: 1,
      })
      // Box 2 fades in
      .to(boxes[1], {
        opacity: 1,
        zIndex: 2,
        opacity: 0,
        duration: 1,
      })
      // Box 2 fades out and slides back
      .to(boxes[1], {
        opacity: 0.2,
        zIndex: 1,

        duration: 1,
      })
      // Box 3 fades in
      .to(boxes[2], {
        opacity: 1,
        zIndex: 3,

        duration: 1,
      });

    return () => {
      ScrollTrigger.getAll().forEach((instance) => instance.kill());
    };
  }, []);

  return (
    <div>
      <div className={`pb-10`}>
        <div className="realtive">
          <motion.div
            ref={containerref}
            style={{ opacity: containerOpacity }}
            initial={{ opacity: 0 }}
            animate={{ opacity: containerOpacity }}
            transition={{ duration: 0.5 }}
            className="sticky top-10 h-screen flex items-center justify-center "
          >
            <h2 className="lg:text-[180px] md:text-[100px] sm:text-[50px] max-sm:text-[50px] font-bold text-sun-yellow text-center my-10 ">
              Our-Products
            </h2>
            <div className="absolute bottom-20">
              <LoadingProduct />
            </div>
          </motion.div>

          <motion.div
            ref={ref}
            style={{ opacity: marqueeOpacity }}
            initial={{ opacity: 0 }}
            animate={{ opacity: marqueeOpacity }}
            transition={{ duration: 1 }}
            className={` bg-white sticky top-0 -z-1 opacity-5 h-screen allmarque-product ${
              produvview ? "z-1" : "-z-10"
            }`}
          >
            <ProductMarque />
          </motion.div>

          <motion.div
            ref={ref1}
            style={{ opacity: viewMoreOpacity }}
            initial={{ opacity: 0 }}
            animate={{ opacity: viewMoreOpacity }}
            transition={{ duration: 1 }}
            className="flex justify-center items-center h-screen  relative z-1 bg-forging-yellow bg-opacity-50"
          >
            <ViewMoreProduct />
          </motion.div>
        </div>
      </div>

      {/* <div className="product-container">
        <div id="product-box" className="product-box">
          <div className="product-insidebox pbox-1 flex items-center justify-center h-screen">
            <h2 className="lg:text-[180px] md:text-[100px] sm:text-[50px] max-sm:text-[50px] font-bold text-sun-yellow text-center my-10 ">
              Our-Products
            </h2>
            <div className="absolute flex justify-center bottom-20">
              <LoadingProduct />
            </div>
          </div>
          <div className="product-insidebox pbox-2 flex items-center justify-center h-screen">
            <ProductMarque />
          </div>
          <div className="product-insidebox pbox-3 bg-white bg-opacity-50">
            <ViewMoreProduct />
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Product;
